import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './DocumentPdfViewer.css';

export default function DocumentPdfViewer({ open, title, pdfUrl, onClose }) {
  useEffect(() => {
    if (!open) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    document.body.classList.add('document-pdf-open');

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.classList.remove('document-pdf-open');
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="document-pdf-overlay" role="presentation" onClick={onClose}>
      <div
        className="document-pdf-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="document-pdf-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="document-pdf-header">
          <h3 id="document-pdf-title" className="document-pdf-title">
            {title || 'צפייה במסמך'}
          </h3>
          <button
            type="button"
            className="document-pdf-close"
            onClick={onClose}
            aria-label="סגירה"
            title="סגירה"
          >
            ×
          </button>
        </div>

        <div className="document-pdf-body">
          {pdfUrl && (
            <iframe
              className="document-pdf-frame"
              src={pdfUrl}
              title={title || 'מסמך PDF'}
            />
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
